<script setup>
import TextInput from '@/components/TextInput.vue';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import api from '@/libs/api.js';

const router = useRouter();
const errors = ref({});

const form = ref({
    name: '',
    phone: '',
    email: '',
    password: '',
    password_confirmation: '',
    remember: true,
});

const submit = () => {
    api.post('app/register', form.value)
        .then((response) => {
            localStorage.setItem('token', response.data.token);
            router.push({ name: 'dashboard' });
        }).catch((error) => {
            if (error.response.status === 422) {
                errors.value = error.response.data.errors;
            }
        })
};

</script>

<template>
    <div class="w-full grid grid-rows-[56px_1fr] bg-white h-full">
        <router-link :to="{ name: 'login' }" class="w-full flex justify-start items-center px-4">
            <svg class="fill-gray-800 w-6 h-6" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px"
                viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve">
                <g>
                    <g>
                        <path
                            d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12    C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084    c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864    l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z" />
                    </g>
                </g>
            </svg>
        </router-link>
        <div class="w-full px-8 py-4 transform_scale">
            <h1 class="text-3xl font-bold text-gray-800 dark:text-white transform_transition">
                Đăng ký
            </h1>
            <p class="mt-2 transform_transition">
                Tạo tài khoản và kết nối với nhà quản lý của bạn
            </p>
            <form class="w-full">
                <div class="py-8 text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                    <div class="mb-4">
                        <TextInput label="Họ và tên" id="name" type="text" v-model="form.name" :errors="errors.name" />
                    </div>
                    <div class="mb-4">
                        <TextInput label="Số điện thoại" id="phone" type="text" inputmode="numeric" pattern="[0-9]*"
                            v-model="form.phone" :errors="errors.phone" />
                    </div>
                    <div class="mb-4">
                        <TextInput label="Email" id="email" type="email" v-model="form.email" :errors="errors.email" />
                    </div>
                    <div class="mb-4">
                        <TextInput label="Mật khẩu" id="password" type="password" v-model="form.password"
                            :errors="errors.password" />
                    </div>
                    <div class="mb-4">
                        <TextInput label="Nhập lại mật khẩu" id="password_confirmation"
                            v-model="form.password_confirmation" :errors="errors.password_confirmation" />
                    </div>
                </div>
                <div class="relative w-full text-center transform_transition">
                    <button type="button" @click="submit"
                        class="w-full py-3 text-xl bg-green-600 text-white rounded-md cursor-pointer">
                        Đăng ký
                    </button>
                </div>
                <div class="w-full relative pt-4 transform_transition">
                    <p class="flex justify-center items-center gap-1">
                        <span class="dark:text-gray-400">
                            Bạn đã có tài khoản?
                        </span>
                        <router-link :to="{ name: 'login' }" class="font-semibold text-green-600 dark:text-gray-400">
                            Đăng nhập
                        </router-link>
                    </p>
                </div>
            </form>
        </div>
    </div>
</template>
<style scoped>
.transform_transition {
    animation: transform 1s ease-out;
}

@keyframes transform {
    0% {
        transform: translateY(-100%);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.transform_scale {
    animation: scale 1s ease-out;
}

@keyframes scale {
    0% {
        transform: scale(0.99);
        opacity: 0;
    }

    50% {
        transform: scale(1.01);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}
</style>